import { render, staticRenderFns } from "./DictText.vue?vue&type=template&id=48fe4a1e&scoped=true"
import script from "./DictText.vue?vue&type=script&lang=js"
export * from "./DictText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48fe4a1e",
  null
  
)

export default component.exports